import { render } from "./TermsServiceView.vue?vue&type=template&id=23196c75"
import script from "./TermsServiceView.vue?vue&type=script&lang=js"
export * from "./TermsServiceView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__